import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { GlobalService } from './dao/global.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public global: GlobalService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  ngOnInit() {
          this.global.dominio = window.location.origin;
          //this.global.dominio = 'https://techcardapio.com.br';
          //this.global.dominio = 'https://techpedido.com.br';
          //this.global.dominio = 'https://techentrega.com.br';
          //this.global.dominio = 'https://techsapp.com.br';
          console.log(this.global.dominio);
          console.log(window.location.origin);
          // PARA USAR TESTE DEFINIR COMO https://techpedido.com.br
  }
}
